module.exports = __webpack_public_path__ + "static/media/board_view_campus_img_v.d8e2d6ae.jpg";